import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin-top: 5px;
`;

export const Inputs = styled.div`
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 15px;
`;
